import { component } from 'picoapp'
import { get } from '../lib/ajax'
import $ from 'quantdom'
import { getProduct, sessionStorageSetItem } from '../lib/utils'
import app from '../lib/pico-init'

export default component((node) => {
  $(node).on('click', (e) => {
    const dropdownType = $(node).attr('data-dropdown-button-type')
    const target = $(e.target).attr('data-product-handle') == undefined ? e.target.closest('li') : e.target

    if (dropdownType == 'product' && target && $(target).attr('data-product-handle')) {
      const url = new URL(window.location)
      const currentView = url.searchParams.get('view')
      const productHandle = $(target).attr('data-product-handle')
      url.searchParams.delete('variant')
      url.pathname = `/products/${productHandle}`

      // Change essentials handle based on test variant
      const testVariantId = window.igData?.user.getTestGroup('cdd647a8-6202-4256-ad76-ab82c2b67c75')?.id ?? ''
      if ($(target).attr('data-product-handle').includes('prenatal-multi-essentials') && testVariantId) {
        if (testVariantId == '4cbfe0fb-145e-4fc9-899f-71199b4b3cf5') {
          url.pathname = `/products/${productHandle}-2`
        } else if (testVariantId == 'd7ad678a-9e84-4fbe-ba95-88df04d31cfa') {
          url.pathname = `/products/${productHandle}-3`
        }
      }
      // end change essentials handle

      const handle = $(target).attr('data-product-handle')
      const dropdownItems = document.querySelectorAll(`dropdown-button[data-dropdown-button-type="product"] li`)

      dropdownItems.forEach((item) => {
        if (item.getAttribute('data-product-handle') == handle) {
          //update button state
          const selectedImage = document.querySelector(
            `dropdown-button[data-dropdown-button-type="product"] [data-selected-image]`
          )
          const selectedTitle = document.querySelector(
            `dropdown-button[data-dropdown-button-type="product"] [data-selected-title]`
          )
          const selectedDesc = document.querySelector(
            `dropdown-button[data-dropdown-button-type="product"] [data-selected-description]`
          )

          selectedImage.src = item.querySelector('img').src
          selectedImage.alt = item.querySelector('img').alt
          selectedTitle.innerHTML = item.querySelector('[data-item-title]').innerHTML
          selectedDesc.innerHTML = item.querySelector('[data-item-description]').innerHTML

          item.classList.add('tw-hidden', 'selected')
          item.classList.remove('tw-flex')
        } else {
          item.classList.remove('tw-hidden', 'selected')
          item.classList.add('tw-flex')
        }
      })

      window.location.href = url
      // removing replace html funcitonality for now to avoid issues with the scent selector

      // get(url)
      //   .then(async (res) => {
      //     const productData = await getProduct(productHandle)
      //     window.MicroBus.emit(`product:change`, {
      //       name: productHandle,
      //       product: productData,
      //     })
      //     replaceHTML(url, currentView, res)
      //     app.mount(['data-component'])
      //   })
      //   .catch((err) => {
      //     $(e.target).attr('aria-selected', 'false')
      //     console.log('Could not get product', err)
      //   })
    } else if (dropdownType == 'hydration' && target && $(target).attr('data-product-handle')) {
      const hydrationFlavor = $(target).attr('data-product-handle')

      const dropdownItems = document.querySelectorAll(`dropdown-button[data-dropdown-button-type="hydration"] li`)

      dropdownItems.forEach((item) => {
        if (item.getAttribute('data-product-handle') == hydrationFlavor) {
          //update button state
          const selectedImage = document.querySelector(
            `dropdown-button[data-dropdown-button-type="hydration"] [data-selected-image]`
          )
          const selectedTitle = document.querySelector(
            `dropdown-button[data-dropdown-button-type="hydration"] [data-selected-title]`
          )
          const selectedDesc = document.querySelector(
            `dropdown-button[data-dropdown-button-type="hydration"] [data-selected-description]`
          )

          selectedImage.src = item.querySelector('img').src
          selectedImage.alt = item.querySelector('img').alt
          selectedTitle.innerHTML = item.querySelector('[data-item-title]').innerHTML
          selectedDesc.innerHTML = item.querySelector('[data-item-description]').innerHTML

          item.classList.add('tw-hidden', 'selected')
          item.classList.remove('tw-flex')
        } else {
          item.classList.remove('tw-hidden', 'selected')
          item.classList.add('tw-flex')
        }
      })

      window.MicroBus.emit(`variant:change-hydration`, hydrationFlavor)
    } else if (dropdownType == 'prenatal' && target && $(target).attr('data-product-handle')) {
      const prenatalType = $(target).attr('data-product-handle')
      const dropdownItems = document.querySelectorAll(`dropdown-button[data-dropdown-button-type="prenatal"] li`)

      dropdownItems.forEach((item) => {
        if (item.getAttribute('data-product-handle') == prenatalType) {
          //update button state
          const selectedImage = document.querySelector(
            `dropdown-button[data-dropdown-button-type="prenatal"] [data-selected-image]`
          )
          const selectedTitle = document.querySelector(
            `dropdown-button[data-dropdown-button-type="prenatal"] [data-selected-title]`
          )
          const selectedDesc = document.querySelector(
            `dropdown-button[data-dropdown-button-type="prenatal"] [data-selected-description]`
          )

          selectedImage.src = item.querySelector('img').src
          selectedImage.alt = item.querySelector('img').alt
          selectedTitle.innerHTML = item.querySelector('[data-item-title]').innerHTML
          selectedDesc.innerHTML = item.querySelector('[data-item-description]').innerHTML

          item.classList.add('tw-hidden', 'selected')
          item.classList.remove('tw-flex')
        } else {
          item.classList.remove('tw-hidden', 'selected')
          item.classList.add('tw-flex')
        }
      })

      window.MicroBus.emit(`variant:change-prenatal`, prenatalType)
    } else if (dropdownType == 'variant' && target && $(target).attr('data-product-id')) {
      //change variant to selected variant
      const variantId = $(target).attr('data-product-id')
      window.MicroBus.emit(`variant:change`, variantId)
    } else if (dropdownType == 'omega type' && target) {
      const dropdownItems = document.querySelectorAll(`dropdown-button[data-dropdown-button-type="${dropdownType}"] li`)
      updateDropdownState(dropdownType, dropdownItems, target)
      const omegaType = $(target).attr('data-variant-title')
      const omegaHandle = $(target).attr('data-product-handle')
      let optionPosition = document
        .querySelector(`dropdown-button[data-dropdown-button-type="${dropdownType}"]`)
        .getAttribute('data-dropdown-option-position')

      if (!optionPosition) {
        optionPosition = 'option1'
      }

      const detail = {
        omegaType,
        optionPosition,
        omegaHandle,
      }

      window.MicroBus.emit(`variant:change-omega`, detail)
    }
  })

  function updateDropdownState(dropdownType, dropdownItems, target) {
    dropdownItems.forEach((item) => {
      if (item.getAttribute('data-product-id') == $(target).attr('data-product-id')) {
        const selectedImage = document.querySelector(
          `dropdown-button[data-dropdown-button-type="${dropdownType}"] [data-selected-image]`
        )
        const selectedTitle = document.querySelector(
          `dropdown-button[data-dropdown-button-type="${dropdownType}"] [data-selected-title]`
        )
        const selectedDesc = document.querySelector(
          `dropdown-button[data-dropdown-button-type="${dropdownType}"] [data-selected-description]`
        )
        const selectedVariantTitle = document.querySelector(`dropdown-button[data-selected-variant-title]`)

        selectedImage.src = item.querySelector('img').src
        selectedImage.alt = item.querySelector('img').alt
        selectedTitle.innerHTML = item.querySelector('[data-item-title]').innerHTML
        selectedDesc.innerHTML = item.querySelector('[data-item-description]').innerHTML
        selectedVariantTitle.setAttribute('data-variant-title', item.getAttribute('data-variant-title'))

        item.classList.add('tw-hidden', 'selected')
        item.classList.remove('tw-flex')
      } else {
        item.classList.remove('tw-hidden', 'selected')
        item.classList.add('tw-flex')
      }
    })
  }

  function replaceHTML(url, currentView, res, pushState = true) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const el = doc.querySelector('#product-above-fold')
    const html = el.innerHTML

    $('#product-above-fold').html(html)

    if (currentView) url.searchParams.set('view', currentView)
    url.searchParams.set('variant', doc.querySelector('#product-above-fold').getAttribute('data-variant-id'))
    sessionStorageSetItem(url.href, res)
    if (pushState) {
      history.replaceState({}, '', url.href)
    }
    if (window?.testIsControl === false) {
      const els = document.querySelectorAll('[data-test-variant-active]')
      if (Array.from(els).length > 0) {
        Array.from(els).forEach((el) => {
          el.setAttribute('data-test-variant-active', 'true')
        })
      }
    }

    window.MicroBus.emit(`product:html-replaced`, {
      one_time_id: doc.querySelector('#product-above-fold').getAttribute('data-variant-id'),
      three_month_id: doc.querySelector('#product-above-fold').getAttribute('data-three-month-variant-id'),
      selling_plan_id: doc.querySelector('#product-above-fold').getAttribute('data-selling-plan-id'),
    })

    StampedFn?.reloadUGC()
  }

  window.MicroBus.on(`variant:change`, (e) => {
    const variantId = e.detail
    const variantDropdownItems = document.querySelectorAll(`dropdown-button[data-dropdown-button-type="variant"] li`)
    const variantHasOverrideText = $(`.js-promo-call-out[data-${variantId}-override-text]`).el()

    const practitionerActive = $(`.js-promo-call-out`).attr('data-practitioner-active')
    const affiliateName = window?.CartJS?.getAttribute('wholesaler_name')
    const isPlan = $(`.js-promo-call-out`).attr('data-is-plan')

    function calcStackedDiscount(a, b) {
      return Math.round(a + b - (a * b) / 100)
    }
    if (window?.testIsControl === false) {
      const els = document.querySelectorAll('[data-test-variant-active]')
      if (Array.from(els).length > 0) {
        Array.from(els).forEach((el) => {
          el.setAttribute('data-test-variant-active', 'true')
        })
      }
    }

    if (variantHasOverrideText) {
      let overrideText = $(`.js-promo-call-out`).attr(`data-${variantId}-override-text`)
      const overrideColor = $(`.js-promo-call-out`).attr(`data-${variantId}-override-background-color`)
      const overrideIconEnabled = $(`.js-promo-call-out`).attr(`data-${variantId}-enable-icon`)
      if (overrideText) {
        if (window?.evergreen_sale?.enabled && window?.evergreen_sale?.percent && window?.evergreen_sale?.code) {
          overrideText = overrideText.replace('[discount_percent]', window?.evergreen_sale?.percent)
          overrideText = overrideText.replace('[discount_code]', window?.evergreen_sale?.code)
        }
        $(`.js-promo-call-out-text`).text(overrideText)
        $('.js-promo-call-out').attr('data-override-active', 'true')
        if (overrideColor) {
          $('.js-promo-bg').css('background-color', overrideColor)
          $('.js-promo-bg-icon>path').attr('fill', overrideColor)
        }
        if (overrideIconEnabled == 'true') {
          $('.js-promo-call-out-icon').attr('aria-hidden', false)
        } else {
          $('.js-promo-call-out-icon').attr('aria-hidden', true)
        }
      }
    } else if (practitionerActive == 'true' && affiliateName) {
      let text = $('.js-promo-call-out').attr('data-practitioner-text')
      if (text) {
        text = text.replace('[name]', affiliateName)
        if (window?.evergreen_sale?.enabled && window?.evergreen_sale?.percent && window?.evergreen_sale?.code) {
          text = text.replace('[discount_code]', window.evergreen_sale.code)
          const stackedDiscount = $('.js-promo-call-out').attr('data-plan-discount')
          if (isPlan == 'true' && stackedDiscount) {
            text = text.replace('[discount_percent]', stackedDiscount + '%')
          } else {
            let sellingPlanMonths = null
            let additionalDiscount = 0

            if ($('.js-delivery-dropdown').el()) {
              sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
            }
            if (sellingPlanMonths == 0) {
              text = text.replace('[discount_percent]', window.evergreen_sale.percent + '%')
            } else {
              if (sellingPlanMonths == 1) additionalDiscount = 10
              if (sellingPlanMonths == 3) additionalDiscount = 15
              if (sellingPlanMonths == 6) additionalDiscount = 25
              if (sellingPlanMonths == 9) additionalDiscount = 30
              text = text.replace(
                '[discount_percent]',
                calcStackedDiscount(window.evergreen_sale.percent, additionalDiscount) + '%'
              )
            }
          }
        }
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if (isPlan == 'true') {
      let text = $('.js-promo-call-out').attr('data-sub-text')
      const stackedDiscount = $('.js-promo-call-out').attr('data-plan-discount')
      if (text) {
        if (
          window?.evergreen_sale?.enabled &&
          window?.evergreen_sale?.percent &&
          window?.evergreen_sale?.code &&
          stackedDiscount
        ) {
          text = text.replace('[discount_percent]', stackedDiscount + '%')
          text = text.replace('[discount_code]', window.evergreen_sale.code)
        }
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if (
      window?.evergreen_sale?.enabled &&
      window?.evergreen_sale?.percent &&
      window?.evergreen_sale?.code &&
      $('.js-promo-call-out').el()
    ) {
      let sellingPlanMonths = null
      if ($('.js-delivery-dropdown').el()) {
        sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
      }
      let text = null
      let additionalDiscount = 0
      if (sellingPlanMonths == 0) {
        text = $('.js-promo-call-out').attr('data-otp-text')
        if (text) text = text.replace('[discount_percent]', window.evergreen_sale.percent + '%')
      } else {
        text = $('.js-promo-call-out').attr('data-sub-text')
        if (sellingPlanMonths == 1) additionalDiscount = 10
        if (sellingPlanMonths == 3) additionalDiscount = 15
        if (sellingPlanMonths == 6) additionalDiscount = 25
        if (sellingPlanMonths == 9) additionalDiscount = 30
      }
      if (text) {
        text = text.replace(
          '[discount_percent]',
          calcStackedDiscount(window.evergreen_sale.percent, additionalDiscount) + '%'
        )
        $('.js-promo-call-out-text').text(text.replace('[discount_code]', window.evergreen_sale.code))
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if ($('.js-promo-call-out').el()) {
      let sellingPlanMonths = null
      if ($('.js-delivery-dropdown').el()) {
        sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
      }
      let text = null
      if (sellingPlanMonths == 0) {
        text = $('.js-promo-call-out').attr('data-otp-text')
      } else {
        text = $('.js-promo-call-out').attr('data-sub-text')
      }
      if (text) {
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    }

    if (variantDropdownItems) {
      for (let i = 0; i < variantDropdownItems.length; i++) {
        if (variantDropdownItems[i].getAttribute('data-product-id') == variantId) {
          variantDropdownItems[i].classList.add('tw-hidden', 'selected')
          variantDropdownItems[i].classList.remove('tw-flex')

          //update button state
          const selectedImage = document.querySelector(
            `dropdown-button[data-dropdown-button-type="variant"] [data-selected-image]`
          )
          const selectedTitle = document.querySelector(
            `dropdown-button[data-dropdown-button-type="variant"] [data-selected-title]`
          )

          selectedImage.src = variantDropdownItems[i].querySelector('img').src
          selectedImage.alt = variantDropdownItems[i].querySelector('img').alt

          selectedTitle.innerHTML = variantDropdownItems[i].querySelector('span').innerHTML
        } else {
          variantDropdownItems[i].classList.remove('tw-hidden', 'selected')
          variantDropdownItems[i].classList.add('tw-flex')
        }
      }
    }
  })
})
